// Notification permission and display utilities

let serviceWorkerRegistration = null;

export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      if (serviceWorkerRegistration) {
        return serviceWorkerRegistration;
      }

      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        serviceWorkerRegistration = registration;
        console.log('Service Worker registration reused successfully:', registration.scope);
        return registration;
      }

      return null;
    } catch (error) {
      console.error('Service Worker lookup failed:', error);
      return null;
    }
  }
  return null;
};

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

export const showNotification = (title, body, icon = '🚨', data = {}, actions = []) => {
  if (Notification.permission === 'granted') {
    if (serviceWorkerRegistration && actions.length > 0) {
      return showServiceWorkerNotification(title, body, icon, data, actions);
    } else {
      return showRegularNotification(title, body, icon, data);
    }
  }
  return null;
};

const showServiceWorkerNotification = async (title, body, icon, data, actions) => {
  try {
    if (!serviceWorkerRegistration && 'serviceWorker' in navigator) {
      serviceWorkerRegistration = await navigator.serviceWorker.getRegistration();
    }

    if (!serviceWorkerRegistration) {
      return showRegularNotification(title, body, icon, data);
    }

    await serviceWorkerRegistration.showNotification(title, {
      body,
      icon: '/lifelog-icon-192.png',
      badge: '/lifelog-icon-32.png',
      tag: data.incidentId || 'incident-followup',
      requireInteraction: true,
      data: data,
      actions: actions,
    });

    console.log(`📱 Service Worker notification sent: "${title}" with ${actions.length} actions`);
    return true;
  } catch (error) {
    console.error('Error showing service worker notification:', error);
    return showRegularNotification(title, body, icon, data);
  }
};

const showRegularNotification = (title, body, icon, data) => {
  const notification = new Notification(title, {
    body,
    icon: '/lifelog-icon-192.png',
    badge: '/lifelog-icon-32.png',
    tag: data.incidentId || 'incident-followup',
    requireInteraction: true,
    data: data,
  });

  notification.onclick = () => {
    window.focus();
    // Log notification click with available data
    console.log(`Follow-up notification clicked for incident ${data.incidentId || 'unknown'}, stage ${(data.followUpIndex || 0) + 1}`);
    notification.close();
  };

  setTimeout(() => {
    notification.close();
  }, 30000);

  return notification;
};
